export default __webpack_public_path__ + "0a53a4a9f2fa6e9c4e4e7da8e5c9d99a.png";